<app-header></app-header>

<div style="background: #f5f5f5 !important;">
    <div class="row">
        <div class="col-12" style="text-align: center;">
            <div class="logo-icon-head">
                <a style="pointer-events: none;" class="logo"><img width="{{imgWidth}}" height="{{imgHeight}}" src="assets/images/{{logo}}" class="img-responsive" style="  pointer-events: none;  background: transparent; 
                    
    margin-left: 0px;
    margin: auto;
    margin-top: 0px;
    margin-bottom: 8px;
                "></a>
                 <div style="float: right; margin-top: 10px; margin-right: 10px; margin-bottom: 5px;">
                  <button  (click)="logout()" class="apply-btn cust-green" style="text-align: right; margin-top: 0px !important; background: #ff9113 !important; color: white;"  id="logoutBtn"> Home </button>
              </div>
              </div>
        </div>
        <!-- <div class="col-4">
            <div class="frm-group" style="float: right;    margin-right: 30px;
            margin-top: 10px;
            margin-bottom: 5px;">
                <button  (click)="logout()" class="apply-btn cust-green" style="text-align: right; margin-top: 0px !important; background: #ff9113 !important; color: white;"  id="logoutBtn"> Home </button>
            </div> 
        </div> -->
    </div>
    <div style="margin-top: 0px;">
        <ng-container >

            <!-- <div class="row" style="padding: 10px;  ">
                <div class="col-12 col-md-6">
          
                  <ng-container *ngFor="let feature of featuresList; index as ind">
                    <button  (click)="setActiveFeatures(ind)" style="    border: none; padding: 15px 0; width: 100%;">
                      <div class="d-flex">
                        <div [ngClass]="'counting-man counting-li'">{{feature.index}}</div>
                        <div style="text-align: left;padding-left:10px; padding-right: 15px;">
                          <div [ngClass]="activeFeatures == feature.index ? 'feature-title active' : 'feature-title'"> {{feature.title}}</div>
                          <div class="flashcards">{{feature.description}}</div>
                          <ng-container *ngIf="feature.isSubscribeBtn">
                            <button style="margin: 10px;" class="btn btn-primary" (click)="gotoplan()">Subscribe Now</button>
                          </ng-container>
                          <ng-container *ngIf="feature.isLoginBtn">
                            <button style="margin: 10px;" class="btn btn-primary" (click)="gotoLogin()">Login</button>
                          </ng-container>
                        </div>
                      </div>
                    </button>
                  </ng-container>
          
          
                  
                </div>
                <div class="col-12 col-md-6">
                  <div style="position: relative;">
                    <div>
                        <img src="{{selectedHowItWorksSrc}}" style="width: 100%; max-width: 500px;">
                    </div>
                  </div>
                </div>
            </div> -->


            <!-- <div style="width: 100%; height:100%;background: #fff;text-align: center;">
                <h4  style="padding-top: 30px;">Free Users can only download Current Affairs & Important News Analysis</h4>
               <h4 style="padding: 10px;padding-top: 30px;">Please subscribe to Download all 8 PDF's daily</h4>
               <button style="margin: 10px;" class="btn btn-primary" (click)="gotoplan()">Subscribe Now</button>
               <h4 style="padding: 10px;padding-top: 30px;">If Already Purchased, Please Login</h4>
               <button style="margin: 10px;" class="btn btn-primary" (click)="gotoLogin()">Login</button>
            </div> -->
        </ng-container>
        <ng-container *ngIf="pdfId">
            <iframe [src]="hrankerurl | safe" style="width: 100%; height:100vh;background: #fff;">

            </iframe>
        </ng-container>
        <ng-container *ngIf="!pdfId">
            <iframe [src]="baseHrankerurl | safe" style="width: 100%; height:100vh;background: #fff;">

            </iframe>
        </ng-container>
        
    </div>
</div>